<template>
  <i>
    <i v-if="iconfont" class="gj-icon">
      <svg aria-hidden="true" width="1em" height="1em" fill="currentColor">
        <use :xlink:href="'#' + iconfont"></use>
      </svg>
    </i>
  </i>
</template>

<script>
  export default {
    name: "gj-icon",
    props: {
      iconfont: {
        type: String
      }
    }
  }
</script>

<style scoped>
  .gj-icon {
    display: inline-block;
    color: inherit;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    vertical-align: -0.125em;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
